import { useRef } from 'react';
import { useFenetreModale } from '../useFenetreModale';
import type { ControleSolde } from '../../../types';
import { dePrenom, formatHeures, type Voix } from './textesDemande';

interface Props { controle: ControleSolde; voix: Voix; envoi: boolean; onRevenir: () => void; onEnvoyerQuandMeme: () => void }

/** « Solde de vacances insuffisant » : un avertissement, jamais un blocage. Par-dessus la page ; « Revenir » est le choix par défaut (Échap). */
export function FenetreSolde({ controle, voix, envoi, onRevenir, onEnvoyerQuandMeme }: Props) {
  const revenir = useRef<HTMLButtonElement>(null);
  const { ref } = useFenetreModale(() => { if (!envoi) onRevenir(); }, { focusInitial: () => revenir.current });
  return (
    <div className="modal-overlay">
      <div className="modal" role="dialog" aria-modal="true" aria-labelledby="nd-solde-t" ref={ref}>
        <div className="modal-header">
          <h3 className="modal-title" id="nd-solde-t">Solde de vacances insuffisant</h3>
          <button type="button" className="close-btn" aria-label="Fermer" onClick={onRevenir} disabled={envoi}>✕</button>
        </div>
        <div className="modal-body">
          <p className="text-sm text-ink-1">
            {voix.pourMoi ? 'Votre solde' : `Le solde ${dePrenom(voix.prenom || 'la personne absente')}`} de vacances dans Tipee ({formatHeures(controle.solde_heures)}) ne couvre pas cette
            absence ({formatHeures(controle.heures_demandees)}). Voulez-vous quand même envoyer la demande ? Les RH seront informé·e·s qu'elle dépasse le solde.
          </p>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn" ref={revenir} onClick={onRevenir} disabled={envoi}>Revenir</button>
          <button type="button" className="btn btn-accent" onClick={onEnvoyerQuandMeme} disabled={envoi}>
            {envoi ? <span className="spinner spinner-sm" aria-label="Envoi en cours" /> : 'Envoyer quand même'}
          </button>
        </div>
      </div>
    </div>
  );
}
